export default {
    data() {
        return {
            dictionaries: {
                languages: [
                    {
                        id: 'ru',
                        name: 'Русский',
                        quotesSvgAiText: 'Материал подготовлен с использованием ИИ-технологии «ИнФорум»',
                    },
                    {
                        id: 'en',
                        name: 'Английский',
                        quotesSvgAiText: 'These materials were prepared using InForum AI technology',
                    },
                ],
            },
        };
    },
}
